import { request } from "../utils/request.js"

smsRecord_getImgCaptcha

export const smsRecord_getImgCaptcha = (pojo, args) => request({
    url: 'smsRecord/getImgCaptcha',
    method: 'GET',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const smsRecord_checkImgCaptcha = (pojo, args) => request({
    url: 'smsRecord/checkImgCaptcha',
    method: 'POST',
    params: pojo,
    showSuccessMessage: true,
    showFailMessage: true,
    ...args
})

export const smsRecord_TenantRegister = (pojo, args) => request({
    url: 'smsRecord/TenantRegister',
    method: 'POST',
    params: pojo,
    showSuccessMessage: true,
    showFailMessage: true,
    ...args
})

export const smsRecord_TouristLogin = (pojo, args) => request({
    url: 'smsRecord/TouristLogin',
    method: 'POST',
    params: pojo,
    showSuccessMessage: true,
    showFailMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/smsRecord.js